import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const cards = [
    {
      icon: <FaMapMarkerAlt size={28} color="#2563eb" />,
      title: "Address",
      content: (
        <>
          Jl. Science Boulevard Blok A2 No.8 <br />
          Kawasan Industri Jababeka Tahap 5 <br />
          Cikarang Timur, Bekasi 17530
        </>
      ),
    },
    {
      icon: <FaEnvelope size={28} color="#16a34a" />,
      title: "Email",
      content: (
        <>
          Mulyadi@otokresindo.com <br />
          admin@otokresindo.com <br />
          marketing@otokresindo.com
        </>
      ),
    },
    {
      icon: <FaPhoneAlt size={28} color="#f59e0b" />,
      title: "Contact Person",
      content: (
        <>
          (+62) 812-9610-043 <br />
          Bpk. Mulyadi - Direktur<br />
          (+62) 878-7797-7848 <br />
          Ibu. Imaa - Marketing
        </>
      ),
    },
  ];

  return (
    <section
      id="contact"
      style={{
        padding: "5rem 2rem",
        background: "#f9fafb",
      }}
    >
      {/* Judul */}
      <h2
        style={{
          textAlign: "center",
          fontSize: "2.2rem",
          fontWeight: "bold",
          marginBottom: "3rem",
          color: "#111827",
        }}
      >
        Contact Us
      </h2>

      {/* Grid Kontak */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "2rem",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {cards.map((card, index) => (
          <div
            key={index}
            style={{
              background: "linear-gradient(135deg, #bbf7d0, #fef08a, #e5e7eb)",
              padding: "1.8rem",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              color: "#111",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
            }}
          >
            {card.icon}
            <h3
              style={{
                marginTop: "1rem",
                fontSize: "1.2rem",
                fontWeight: "bold",
                color: "#111827",
              }}
            >
              {card.title}
            </h3>
            <p
              style={{
                marginTop: "0.5rem",
                lineHeight: "1.6",
                fontSize: "0.95rem",
                color: "#374151",
              }}
            >
              {card.content}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Contact;
